export default {
  'Рекомендации': 'recommendations',
  title: {
    segments: 'Segments',
    attributes: 'Attributes'
  },
  color_switcher: {
    dark: 'Dark',
    light: 'Light'
  },
  routes: {
    product_recommendations: 'Product recommendations',
    recommendations: 'Recommendations',
    bisness_rules: 'Bisness rules',
    new_business_rules: 'New business rule',
    instruments: 'Instruments',
    pipeline: 'Scenarios',
    pipeline_hint: 'Scenario editor: email, push and condition chains.',
    authorization: 'Authorization',
    desktop: 'Desktop',
    personal_area: 'Personal Area',
    multilead: 'Multilead',
    lead: 'Lead',
    leads: 'Leads',
    allleads: 'All Leads',
    statistic: 'Statistic',
    visits: 'Visits',
    visit: 'Visit',
    cart: 'Cart',
    letters: 'Letters',
    forms: 'Forms',
    segments: 'Segments',
    editing: 'Editing',
    assortment: 'Assortment',
    allemails: 'All Emails',
    autocast: 'Email autocast',
    editing_autocast: 'Editing autocast',
    create_autocast: 'Create Autocast',
    emails: 'Emails',
    create_email: 'New mass email campaign',
    auto_emails: 'Auto Emails',
    widgets: 'Widgets',
    emails_templates: 'Emails Templates',
    emails_template: 'Emails Template',
    promotional_codes: 'Promotional Codes',
    reports: 'Reports',
    all_orders: 'All orders',
    customer_orders: 'Customer orders',
    analytics: 'Analytics',
    analytics_leads: 'Analytics by Leads',
    analytics_visits: 'Analytics by Visits',
    analytics_emails: 'Analytics by Emails',
    analytics_widgets: 'Analytics by Widgets',
    analytics_recommendations: 'Analytics by Recommendations',
    analytics_emails_dynamics: 'Analytics by Emails Dynamic',
    analytics_autocasts: 'Analytics by Autocasts',
    analytics_sales_funnel: 'Analytics by Sales Funnel',
    analytics_sales: 'Analytics by Sales',
    analytics_offers: 'Analytics by Offers',
    analytics_rfm: 'RFM Analysis',
    offers: 'Offers',
    kpi_store: 'KPI store',
    average_check: 'Average check',
    paid_offers_rate: 'Paid offers rate',
    purchase_rate: 'Purchase rate',
    returned_customers: 'Returned customers',
    library: 'Library',
    image: 'Image',
    integration: 'Integration',
    settings: 'Settings',
    settings_account: 'Account Settings',
    change_password: 'Change Password',
    settings_alerts: 'Settings Alerts',
    sites_list: 'List of sites',
    users: 'Users',
    tool_management: 'Tool Management',
    timeline: 'Timeline',
    efficiency_leadhit: 'LeadHit Efficiency',
    site_forms: 'Site forms'
  },
  side_menu: {
    by_visits: 'Visits',
    by_leads: 'Leads',
    by_emails: 'Emails',
    by_widgets: 'Widgets',
    by_recommendations: 'Recommendations',
    by_emails_dynamic: 'Emails dynamic',
    by_autocasts: 'Autocasts',
    by_sales_funnel: 'Sales funnel',
    by_sales: 'Sales',
    app_language: 'App language',
    app_languages: 'App languages',
    your_profile: 'Your profile',
    profile_settings: 'Profile settings',
    my_sites: 'My sites',
    my_users: 'My users',
    by_efficiency_leadhit: 'LeadHit Efficiency',
    by_offers: 'Offers',
    rfm_analysis: 'RFM Analysis'
  },
  mini_dashbord: {
    instruments_widgets:
      'This section has collected for you all the data on the operation of widgets on your site',
    instruments_message_campaings:
      'Track the performance of message campaings with our analytics service',
    instruments_autocast:
      'Monitor the performance of your email autocast and track their performance',
    leads_leads: 'Got the whole analytical database for the right period',
    leads_segments: 'Group users into different segments to create the best product offer for each',
    instruments_recommendations: 'All active and inactive LeadHit product recommendations',
    instruments_bisness_rules:
      'List of business rules that you have assigned for each product on your site',
    instruments_user_alerts:
      'Here is a complete list and history of alerts that you configured yourself',
    library_image: 'All images uploaded by you. Available for work with service tools',
    library_emails_templates: 'A complete list of your active and inactive newsletter templates',
    library_promocodes: 'Complete list and statistics for your promotional codes',
    reports_all_orders: 'Get complete analytics on orders for the right period',
    reports_recomendations:
      'Collect reports on the effectiveness of recommendations for a certain period or for the entire duration of the service',
    reports_message_campaings: 'Get all the necessary message campaings reports',
    reports_autocast: 'Get all the necessary autocast reports',
    efficiency_leadhit: 'Find out how many orders LeadHit service brought you',
    reports_sources_of_orders: 'Track the most profitable sources of orders',
    instruments_loyalty_categories: 'Loyalty categories used in the work of the LeadHit service',
    instruments_loyalty_rules: 'Rules for determining the category of loyalty'
  },
  confirm_leave_route: 'Are you sure you want to leave the page? The entered data will be lost.',
  receive: 'Receive',
  racoon_header_text: 'Welcome to your LeadHit account',
  equals: 'Equal',
  does_not_equal: 'Not equal',
  russian: 'Russian',
  english: 'English',
  deutsch: 'Deutsch',
  back: 'Back',
  yes: 'Yes',
  no: 'No',
  offer_title: 'Name',
  error_request_data: 'Invalid data request',
  error: 'Error',
  lead: 'Lead',
  lead_email: 'Lead email',
  lead_name: 'Lead name',
  sign_in: 'Sign in',
  registration: 'Registration',
  sign_up: 'Sign up',
  enter_login: 'Enter login',
  enter_password: 'Enter password',
  enter_email: 'Enter e-mail',
  enter_phone: 'Enter phone',
  confirm_processing_user_data: 'I consent to the processing of my personal data',
  registration_password_error: 'Password must be at least 8 characters',
  you_can_check_mail: 'You can check mail',
  we_sent_information_to_mail: 'We sent information to the mail',
  i_forgot_password: 'I forgot password',
  success_registration_confirm_message: 'User successfully registered',
  enter_new_password: 'Enter new password',
  password_success_updated: 'Password updated successfully',
  marketing_automation_service: 'Marketing automation service',
  data_out_of_date: 'Data is out of date',
  repeat_confirm_registration_description:
    'Enter your email so that we can resend the registration letter!',
  name: 'Name',
  surname: 'Surname',
  add_1: 'Additional field 1',
  add_2: 'Additional field 2',
  add_3: 'Additional field 3',
  add_4: 'Additional field 4',
  add_5: 'Additional field 5',
  last_name: 'Surname',
  company: 'Company',
  position: 'Position',
  birthday: 'Birthday',
  email: 'Email',
  sex: 'Sex',
  index: 'Postcode',
  country: 'Country',
  region: 'Region',
  city: 'City',
  address: 'Address',
  sub_type: 'Subscription type',
  discount_size: 'Discount size',
  order_id: 'Order Id',
  cart_sum: 'Order sum',
  save: 'Save',
  cancel: 'Cancel',
  add: 'Add',
  tool_setup: 'Tool Setup',
  no_data: 'No data',
  apply: 'Apply',
  create: 'Create',
  reset: 'Reset',
  show: 'Show',
  hide: 'Hide',
  send: 'Send',
  choice: 'Choice',
  choose_a_period: 'Choose a period',
  delete_selected: 'Delete selected',
  import: 'Import',
  more_details: 'More details',
  total: 'Total',
  used: 'Used',
  alerts: 'Alerts',
  remained: 'Remained',
  start_typing: 'Start typing',
  uploaded: 'Uploaded',
  download: 'Download',
  generate: 'Generate',
  edit: 'Edit',
  delete: 'Delete',
  select_from_list: 'Select from list',
  from_list: 'From list',
  select_all: 'Select all',
  password: 'Password',
  phone: 'Phone',
  timed_out: 'Timed out',
  version: 'Version',
  close: 'Close',
  align: 'Align',
  copy: 'Copy',
  time: 'Time',
  hours: '{n} hours | {n} hours | {n} hours',
  minutes: '{n} minutes | {n} minutes | {n} minutes',
  pcs: 'pcs',
  minute: 'minutes',
  amount_total: 'Amount, total',
  select: 'Select',
  date: 'Date',
  category: 'Сategory',
  categories: 'Сategories',
  logout: 'Log out',
  product_introduction: 'Product introduction',
  choose_site: 'Choose site',
  switch_language: 'Switch language',
  toggle_color_theme: 'Toggle color theme',
  no_sites_available: 'No sites available',
  segment: 'Segment',
  group: 'Group',
  descending: 'Descending',
  ascending: 'Ascending',
  data_successfully_sent_to_email: 'Data has been successfully sent to email',
  choose_all: 'Choose all',
  update: 'Update',
  misc: 'Additional information',
  desktop: {
    weekly_sales_funnel: 'Weekly sales funnel',
    shown: 'Shown',
    widgets_are_active: 'Widgets are active',
    widgets_count: '{n} widget | {n} widgets | {n} widgets',
    orders_per_week: 'Orders per week',
    visits_per_week: 'Visits per week',
    with_leadhit: 'with LeadHit',
    earned: 'Earned',
    earned_with_leadhit: 'Earned with LeadHit',
    percentage_of_income_from_using_LeadHit: 'Percentage of income from using LeadHit'
  },
  auth: {
    entered_parameters_incorrect: 'Entered parameters is incorrect',
    everything_is_ready: 'Everything is ready',
    check_inbox_mobile_text_first: 'We sent you',
    check_inbox_mobile_text_second: 'the information in the mail',
    marketing_automation: 'Marketing automation',
    too_many_attempts_try_again_later: 'Too many attempts, try again later',
    not_a_valid_email_address: 'Not a valid email address'
  },
  information: 'Information',
  status: 'Status',
  settings: {
    total_offers_count: 'Total offers',
    unavailable_offers_count: 'Unavailable offers',
    spf_correct: 'SPF record is set correctly',
    spf_not_correct: 'SPF record is set incorrectly',
    the_domain_should_look_like_this: 'The domain should look like this',
    failed_to_load_feed: 'Failed to load feed',
    send_information_to_the_developer: 'Send information to your developer',
    send_all: 'Send all',
    enter_feed_link: 'Enter feed link',
    tracker_code_connected: 'Tracker code connected',
    order_code_connected: 'Order code connected',
    tracker_code_not_connected: 'Tracker code not connected',
    order_code_not_connected: 'Order code not connected',
    get_order_code: 'Get order code',
    get_tracker_code: 'Get tracker code',
    order_code: 'Order code',
    webpush_sw_file: 'Web Push notification file',
    tracker_code: 'Tracker code',
    update_offers_via_file_feed: 'Update offers via file feed',
    are_you_sure_you_want_to_delete_the_feed: 'Are you sure you want to delete the feed?',
    feed_not_added: 'Feed not connected',
    feed_added: 'Feed connected',
    write_to_tech_support: 'Write to tech support',
    upload_feed: 'Upload feed',
    change_feed: 'Change feed',
    delete_feed: 'Delete feed',
    technical_account_settings: 'Technical account settings',
    get_weekly_reports: 'Receive weekly reports',
    new_password: 'New password',
    turn_off_all: 'Turn off all',
    turn_on_all: 'Turn on all',
    product_alerts: 'Product Alerts',
    invoice_alerts: 'Invoice Alerts',
    service_alerts: 'Service Alerts',
    commercial_alerts: 'Commercial Alerts',
    add_domain: 'Add domain',
    add_site: 'Add site',
    enter_domain_URL: 'Enter domain URL',
    enter_feed_URL: 'Enter feed URL',
    site_successfully_created: 'Site successfully created',
    error_creating_site: 'Error creating site',
    activity: 'Activity',
    add_user: 'Add user',
    login: 'Login',
    mail: 'Mail',
    domain: 'Domain',
    domain_name: 'Domain name',
    date_added: 'Date Added',
    feed: 'Feed',
    feed_name: 'Feed name',
    edit_domain: 'Edit domain',
    no_need_update_data: 'No data update needed',
    site_successfully_updated: 'Site successfully updated',
    site_id: 'Site ID',
    technical_settings_of_service: 'Technical settings of the service',
    technical_settings: 'Technical settings',
    information_sent_to_your_developer: 'Information sent to your developer',
    link_for_collecting_forms_on_the_site: 'Link for collecting forms on the site',
    block_banner: 'Block banner',
    subscription: 'Subscription',
    cart_form: 'Cart form',
    final_order_form: 'Final order form',
    block_banner_hint: 'After filling out the form the banner will not be shown',
    cart_form_hint:
      "After filling out the form the banner will not be shown and the status of the visit becomes 'Order start'",
    final_order_form_hint:
      "After filling out the form the banner will not be shown and the status of the visit becomes 'Order'",
    form_settings: 'Form settings',
    site_categories: 'Product Categories',
    site_categories_description: 'Manage product categories for "Abandoned Category" email campaign',
    upload_categories_file: 'Upload categories from file',
    file_requirements: 'File requirements: Column separator - semicolon. Column headers: name, url, id.',
    select_csv_file: 'Select CSV file',
    selected_file: 'Selected file:',
    upload_categories: 'Upload categories',
    uploading: 'Uploading...',
    add_category: 'Add category',
    category_name: 'Category name:',
    category_name_placeholder: 'Enter category name',
    category_url: 'Category URL:',
    category_url_placeholder: 'https://example.com/category',
    yml_category_id: 'YML category ID:',
    yml_category_id_placeholder: 'Enter YML ID',
    adding: 'Adding...',
    category_settings: 'Category Settings',
    url_params_title: 'Key parameters in category URLs',
    url_params_label: 'Parameters (comma separated):',
    url_params_placeholder: 'utm_source, utm_medium, ref',
    save_params: 'Save parameters',
    categories_list: 'Categories list',
    refresh: 'Refresh',
    delete_all: 'Delete all',
    loading_categories: 'Loading categories...',
    no_categories: 'No categories found',
    actions: 'Actions',
    delete: 'Delete',
    confirm_delete_category: 'Are you sure you want to delete this category?',
    delete_category: 'Delete Category',
    confirm_delete_all_categories: 'Are you sure you want to delete all categories?',
    delete_all_categories: 'Delete All Categories',
    delete_all_warning: 'This action cannot be undone. All categories will be permanently deleted.',
    category_uploaded: 'Categories uploaded successfully',
    category_added: 'Category added successfully',
    category_updated: 'Category updated successfully',
    category_deleted: 'Category deleted successfully',
    all_categories_deleted: 'All categories deleted successfully',
    url_params_saved: 'URL parameters saved',
    upload_error: 'Error uploading file',
    add_error: 'Error adding category',
    update_error: 'Error updating category',
    delete_error: 'Error deleting category',
    delete_all_error: 'Error deleting all categories',
    save_params_error: 'Error saving parameters',
    select_csv_error: 'Please select a CSV file',
    search_placeholder: 'Search by category name...',
    delete_selected: 'Delete selected',
    delete_selected_categories: 'Delete selected categories',
    confirm_delete_selected_categories: 'Are you sure you want to delete selected categories?',
    selected_categories_deleted: 'Selected categories deleted successfully',
    delete_selected_error: 'Error deleting selected categories',
    update_form_setting_question: 'Are you sure you want to update the form',
    form_updated_successfully: 'Form updated successfully',
    form_update_error: 'Form update error',
    choose_tariff: 'Choose tariff',
    users: {
      user_name: 'User name',
      role: 'Role',
      sites: 'Sites',
      editing: 'Editing',
      delete: 'Delete',
      manager: 'Manager',
      guest: 'Guest',
      title_for_input_username: 'You can use only latin characters, numbers and underscores',
      invalid_login: 'Invalid login',
      re_enter_password: 'Re-enter Password',
      passwords_do_not_match: 'Passwords do not match',
      invalid_email: 'Invalid email',
      confirm_password: 'Confirm password',
      email: 'Email',
      choose_role: 'Choose role',
      choose_site: 'Choose site',
      you_edited_data: 'You have edited data',
      delete_user: 'Delete user',
      add_new_user: 'Add new user',
      user_data_updated_successfully: 'User data updated successfully',
      you_sure_want_delete_user: 'Are you sure want to delete the user',
      user_will_be_deleted: 'User will be deleted',
      user_successfully_deleted: 'User successfully deleted',
      user_created_successfully: 'User created successfully',
      no_changes: 'No changes',
      please_select_at_least_one_site: 'Please, select at least one site',
      block: 'Block',
      active: 'Аctive'
    }
  },
  notifications: {
    need_soft_redirect: 'To update the cabinet version, please login to your account again',
    notifications_count: '{n} notifications | {n} notifications | {n} notifications',
    you_have: 'You have',
    notifications: 'Notifications'
  },
  timeline: {
    visit_start: 'Start of visit',
    visit_end: 'End of visit',
    page_visit: 'Opened the page',
    cart_item: 'Added item',
    email_clicked: 'Moved from a letter',
    email_delivered: 'Got a newsletter',
    email_opened: 'Opened a letter',
    widget_popup_view: 'Saw a popup with a widget',
    widget_fill: 'Filled widget',
    widgets_close: 'Closed widget',
    recommendations_clicks: 'Click on featured product',
    webpush_shown: 'Saw web push',
    webpush_clicked: 'Clicked web push',
    webpush_closed: 'Dismissed web push',
    webpush_dismissed: 'Dismissed web push',
    form: 'Filled out the form',
    order: 'Place an order',
    default: 'Unknown event',
    select_options_to_filter: 'Select options to filter',
    this_field_displays_the_selected_filters: 'This field displays the selected filters',
    total_events: 'Total events',
    pages_visited: 'Pages visited',
    completed_forms: 'Completed forms',
    received_emails: 'Received emails',
    orders_made: 'Orders made',
    there_are_no_events_for_the_selected_period: 'There are no events for the selected period',
    no_options_to_display: 'No options to display'
  },
  all_leads: {
    double_opt_in: 'Double Opt-in',
    date_of_appearance: 'Date of appearance',
    list_of_all_leads: 'List of all leads',
    no_name: 'No name',
    no_email: 'No email',
    lead_import: 'Lead import',
    overwrite_existing_lead_values: 'Overwrite existing lead values',
    you_can_upload_csv_file_with_leads: 'You can upload a csv file with leads',
    information_about_csv_file_format: 'Information about csv file format',
    no_file_selected: 'No file selected',
    file_size_is_too_large: 'File size is too large',
    number_of_successfully_loaded_leads: 'Number of successfully loaded leads',
    number_of_overwritten_leads: 'Number of overwritten leads',
    number_of_errors: 'Number of errors',
    import_example: {
      name: 'John',
      surename: 'Smith',
      phone: '+12026985253',
      country: 'United States',
      city: 'Washington',
      address: '225 7th St SE',
      sex: 'M/F',
      status: 'New/Contact/Lead/Manager/Regular/Wholesale'
    },
    import_rules: {
      semicolon_must_be_used_as_separator: 'The semicolon (;) must be used as a separator',
      default_status:
        'If you do not indicate the status of the lead, the status will be set to New',
      required_and_optional_field: 'The main field is email, the rest is optional',
      table_example: 'Column headers should be exactly like in the example'
    },
    lead: {
      contact_details: 'Contact details',
      contact_information: 'Contact information',
      unsubscribe: 'Unsubscribe',
      unsubscribe_from_autocasts: 'Unsubscribe from autocasts',
      unsubscribe_from_emails: 'Unsubscribe from emails',
      unsubscribe_from_all_newsletters: 'Unsubscribe from all newsletters',
      all_visits: 'All visits',
      total_visits: 'Total visits',
      visit_status: 'Visit status',
      technical_data: 'Technical data',
      postcode: 'Postcode',
      country: 'Country',
      region: 'Region',
      city: 'City',
      device: 'Device',
      os: 'OS',
      browser: 'Browser',
      viewed_categories: 'Viewed categories',
      viewed_offers: 'Viewed offers',
      number_views: 'Number of views',
      purchased_goods: 'Purchased goods',
      visit_page: 'Visit page',
      add_to_cart: 'Add to cart',
      date_of_completion: 'Date of completion',
      last_step_of_cart: 'Last step of the cart',
      fill_URL: 'Fill URL',
      subscription_settings_changed: 'Subscription settings changed',
      subscription_settings_not_changed: 'Subscription settings have not changed',
      subscription_update_failed: 'Subscription update failed',
      edit_lead_summary_title: 'Editing Lead Information',
      edit_lead_summary_question: 'Are you sure you want to save the lead data changes',
      error_lead_summary: 'Lead data update error',
      lead_summary_success_updated: 'Lead data updated successfully',
      status: {
        new: 'New',
        contact: 'contact',
        customer: 'Customer',
        manager: 'Manager',
        regular: 'Regular',
        wholesale: 'Wholesale'
      }
    }
  },
  segments: {
    segment_created: 'Segment created',
    segment_updated: 'Segment updated',
    segments_deleted: 'Segments deleted',
    segment_deleted: 'Segment deleted',
    lead_groups: 'Lead groups',
    all_segments: 'All segments',
    segment_name: 'Segment name',
    number_leads: 'Number of leads',
    content: 'Content',
    select_segments: 'Select segments',
    add_segment: 'Add segment',
    delete_segments: 'Delete segments',
    delete_segments_question: 'Are you sure you want to remove the following segments?',
    male: 'Male',
    female: 'Female',
    save_segment: 'Save segment',
    appearance_time: 'Appearance time',
    score: 'Score',
    completed_form: 'Completed form',
    sex: 'Sex',
    unsubscribed: 'Unsubscribed',
    loaded: 'Loaded',
    lead_status: 'Lead status',
    sent_mailing: 'Sent mailing',
    order_date: 'Order date',
    last_order_date: 'Last order date',
    selected_filters_empty_placeholder: 'Selected filters will appear here',
    enter_segment_name: 'Enter segment name',
    save_segment_text: 'The segment will be formed by the following parameters',
    select_at_least_one_condition: 'Select at least one condition',
    select_condition: 'Select condition',
    select_operator: 'Select operator',
    define_value: 'Define value',
    no_need_save_data: 'No need to save data',
    copy_segments: 'Copy segments',
    copy_segments_text: 'Enter the name of the new segments',
    export: 'Export',
    export_segments: 'Segment Export',
    segments_sent_to_your_email: 'Segments sent to your e-mail',
    number_of_multilead_orders: 'The number of multilead orders',
    number_of_multilead_visits: 'The number of multilead visits',
    amount_of_multilead_orders: 'Amount of multilead orders',
    date_of_last_site_visit: 'Date of last site visit',
    multilead_time_added: 'Multilead appearance date',
    opened_mass_emails_by_last_n_days: 'Opened mass emails in last N days',
    recieved_mass_messages: 'Received mass emails',
    confirmed_double_opt_in: 'Confirmed DOI'
  },
  image: {
    no_uploaded_images: 'You have no uploaded images',
    max_image_size: 'Maximum upload image size',
    acceptable_image_formats: 'Acceptable Image Formats',
    drag_and_drop_files_to_upload: 'Drag and drop files to upload',
    select_files: 'Select files',
    image_upload: 'Image upload',
    all_uploaded_images: 'All uploaded images',
    not_valid_image_message: 'Incorrect file format(PNG/JPG) or size exceeded',
    images_successfully_uploaded: 'Images successfully uploaded',
    upload_error: 'Error uploading images',
    load_error: 'Error loading images',
    image_successfully_deleted: 'Image successfully deleted',
    delete_error: 'Error deleting image',
    image_successfully_updated: 'Image successfully updated',
    update_error: 'Error updating image',
          url_copied_to_clipboard: 'URL copied to clipboard',
      copy_url_error: 'Error copying URL',
      loading_images: 'Loading images...'
  },
  integration: {
    api_text_generate: `Here you can generate a key for working with Leadhit via API. Indicate it in the header of the POST request with the key 'API-KEY'`
  },
  emails_templates: {
    archive_template: 'Archive email templates',
    unarchive_template: 'Unarchive email templates',
    archive_template_question: 'Are you sure you want to archive the selected template | Are you sure you want to archive the selected templates | Are you sure you want to archive the selected templates',
    unarchive_template_question: 'Are you sure you want to unarchive the selected template | Are you sure you want to unarchive the selected templates | Are you sure you want to unarchive the selected templates',
    emails_template_has_been_archived: 'Template has been archived | Templates has been archived | Templates has been archived',
    emails_template_has_been_unarchived: 'Template has been unarchived | Templates has been unarchived | Templates has been archived',
    show_archived_template: 'Show archived templates',
    name_template: 'Name template',
    channel: 'Channel',
    used_in_autocasts: 'Used in Autocasts',
    active: 'Active / Not active',
    date_of_creation: 'Date of creation',
    delete_template: 'Delete template',
    copy_template: 'Copy template',
    confirm_popup_delete_body_text: 'Are you sure to delete the selected template',
    confirm_popup_copy_body_text: 'Are you sure to copy the selected template',
    name_selected_template: 'Name of selected template',
    template_deleted: 'Template deleted',
    error_deleting_template: 'Error deleting template',
    preview: 'Preview',
    create_new_email_template: 'Create new email template',
    stripo_editor: 'Editor Stripo',
    code_editor: 'Editor code',
    webpush_editor: 'Web Push',
    select_template_type_body_text_first: 'Choose format for new email template',
    select_template_type_body_text_second: 'These formats are incompatible',
    select_template_type_body_text_third_first: 'Template saved in Stripo,',
    select_template_type_body_text_third_second: 'cannot be edited in simple editor, and backwards',
    enter_template_name: 'Enter template name',
    copy_html: 'Copy HTML',
    template_saved_successfully: 'Template saved successfully',
    error_save_template: 'Error saving template',
    code_copied_successfully: 'Code copied successfully',
    hidden_pre_title: 'Hidden Pre-Title',
    preheader_description:
      'Hidden text, that will be displayed, as a continuation of the topic in an email program that is not yet open',
    copy: 'Copy',
    copy_url: 'Copy URL',
    duplicate: 'Copy',
    export_email_template:
      'Export email template | Export email templates | Export email templates',
    confirm_popup_export_body_text:
      'Are you sure to export the selected template | Are you sure to export the selected templates | Are you sure to export the selected templates',
    name_of_selected_email_template:
      'Name of selected email template | Name of selected email templates | Name of selected email templates',
    template_export_error: 'Template export error',
    templates_export_error: 'Templates export error',
    import: 'Import',
    import_email_templates: 'Import email templates',
    overwrite_existing_templates: 'Overwrite existing templates',
    file_format_should_be_html_or_mjml: 'File format should be html or mjml',
    error_reading_files: 'Error reading files',
    template_import_error: 'Template import error',
    number_of_templates_imported_successfully: 'Number of templates imported successfully',
    number_of_templates_not_imported: 'Number of templates not imported',
    choose_template: 'Choose template',
    download_preview: 'Download preview',
    copy_to_clipboard: 'Copy to clipboard'
  },
  promocodes: {
    category_name: 'Category name',
    promo_code_name: 'Promo code name',
    remove_all_of_unused_promotional_codes: 'Remove all of unused promotional codes',
    for_all_time: 'For all time',
    promotion_codes_deleted: 'Promotion codes removed:',
    promotional_codes_uploaded: 'Promotional codes uploaded: ',
    rewritten_promo_codes: 'rewritten promotional codes: ',
    files_entries_that_already_in_the_database: 'files entries that already in the database: ',
    no_loyalty_categories_with_names: 'no loyalty categories with names: ',
    removed: 'removed',
    select_file: 'Select file',
    select_a_category_to_delete: 'Select a category to delete',
    email_must_be_different: 'E-mails must be different',
    mail_for_alerts_updated: 'E-mail for alerts updated',
    are_you_sure_you_want_to_keep_current_mail: 'Are you sure you want to keep current mail?',
    are_you_sure_you_want_to_delete_the_current_mail:
      'Are you sure you want to delete the current e-mail?',
    delete_email_for_alerts: 'Delete e-mail for alerts',
    save_email_for_alerts: 'Save e-mail for alerts',
    search: 'Search',
    delete_everything: 'Delete everything',
    delete_promotional_codes: 'Delete promotional codes',
    remaining_promotional_codes: 'Remaining promotional codes',
    used_promotional_codes: 'Used promotional codes',
    all_promotional_codes: 'All promotional codes',
    active_email: 'Active e-mail',
    enter_new_email: 'Enter new e-mail',
    are_you_sure_you_want_to_remove_the_promotional_codes_from_the_category:
      'Are you sure you want to remove the promotional codes from the category',
    are_you_sure_you_want_to_delete_all_promotional_codes:
      'Are you sure you want to delete all promotional codes?',
    date_of_download: 'Date of download',
    are_you_sure_you_want_to_remove_the_promotional_code:
      'Are you sure you want to remove the promotional code',
    overwrite_existing_ones_by_making_them_available:
      'Overwrite existing ones by making them available',
    import_promotional_codes: 'Import promotional codes',
    editing_mail_for_alerts: 'Editing mail for alerts',
    promotion_code_text_email:
      'Enter an e-mail for notifications if you have run out of promotional codes',
    promotion_code_statistics: 'Promotion code statistics',
    remove_promotional_code: 'Remove promotional code',
    remove_promotional_codes: 'Remove promotional codes',
    promotional_code: 'Promotional Code',
    category: 'Category',
    date_of_use: 'Date of use',
    date_added_to_the_site: 'Date added to the site',
    download_statistics: 'Download statistics',
    download_promotional_codes: 'Download promotional codes',
    download_instructions: 'Download Instructions',
    the_file_format_must_be_csv: 'The file format must be csv'
  },
  offers: {
    store_offers: 'Store offers',
    price: 'Price',
    update_date: 'Update date',
    vendor: 'Seller',
    available: 'Available',
    description: 'Description',
    model: 'Model'
  },
  reports: {
    compare_selected: 'Compare selected',
    clicks: 'Clicks',
    purchases: 'Purchases',
    attribution: 'Attribution',
    attributions: 'Attributions',
    by_orders: 'By orders',
    leadhit_service_reports: 'Leadhit Service Reports',
    end_to_end_analytics: 'End-to-end analytics',
    multi_report: 'Multi Report',
    download: 'Download',
    sources_of_orders: 'Sources of orders',
    statistics: 'Statistics',
    recommendations_report: 'Recommendations Report',
    emails_report: 'Emails Report',
    multichannel: 'Multichannel',
    split_into_groups: 'Split into groups',
    download_report: 'Download report',
    choose_filter: 'Choose filter',
    recommendation_report_exclude_empty_data:
      'Exclude orders without number or amount from the report',
    select_action: 'Select an action',
    autocasts_report: 'Autocasts report',
    after_receiving_email: 'After receiving email',
    report_type: 'Report type',
    mailings_type: 'Mailings type',
    leadhit_efficiency_report: 'LeadHit efficiency report',
    active: 'Active',
    inactive: 'Inactive',
    channel: 'Channel',
    attribution_channel: 'Attribution channel',
    orders_amount: 'Orders amount',
    orders: {
      click_time: 'Click time',
      order_number: 'Order number',
      total_amount: 'Amount',
      number: 'Number',
      source: 'Source',
      time_added: 'Time added',
      order_sum: 'Order sum',
      sum: 'Sum',
      information_about_order: 'Information about order',
      client: 'Lead',
      product_list: 'Product list',
      no_products: 'No products',
      amount: 'Amount',
      total_number_orders: 'Total number of orders',
      total: 'Total',
      exclude_orders_without_number_or_amount:
        'Exclude orders without a number or amount from the report',
      display_unprocessed_order_amounts: 'Display unprocessed order amounts',
      do_not_display_lead_orders_with_manager_status:
        'Do not display lead orders with "Manager" status',
      source_grouping: 'Source grouping'
    },
    diagram_order_count: 'Order quantity chart',
    diagram_total_sum: 'Total order chart',
    period_total: 'Total for the selected period'
  },
  analytic: {
    you_can_select_only_one_type_of_widget: 'You can select only one type of widget!',
    you_can_select_only_one_widget: 'You can select only one widget!',
    you_can_select_only_one_autocast: 'You can select only one autocast!',
    you_can_select_only_one_widget_recommendation: 'You can select only one widget recommendation!',
    message_campaigns_selected: '6 message campaigns selected. This is the maximum amount!',
    by_leads: 'By leads',
    traffic_source: 'Traffic source',
    diagram: 'Diagram',
    channel_groups: 'Channel groups',
    social_networks: 'Social networks',
    search_engines: 'Search engines',
    advertising: 'Advertising',
    other: 'Other',
    no_type: 'No type',
    all_traffic: 'All traffic',
    compare_periods: 'Compare periods',
    by_unique_events: 'By unique events',
    period: 'Period',
    total_per_period: 'Total per period',
    choose_emails: 'Choose emails',
    open_list: 'Show list',
    selection_widget_recommendations: 'Selection of widget recommendations',
    recommendation_widget_analytics: 'Analytics by widget Recommendation',
    recommendation_widget_popup_title: 'Choose one of recommendation widgets',
    clicked_on_recommendations_widget: 'Clicked on recommendations widget',
    order_sum_after_click_widget_recommendation:
      'The amount of orders after clicking on the recommendations widget',
    orders_after_click_widget_recommendation: 'Orders after clicking on the recommendations widget',
    choose_widget: 'Choose widget',
    recommendations_data: 'Recommendations Data',
    choose_recommendation_widget: 'Choose a recommendation widget',
    lead_analytics: 'Lead Analytics',
    choose_autocast_by_name: 'Select autocast by name',
    select_least_one_autocast: 'Please select at least one autocast',
    total_sales: 'Total sales',
    total_revenue: 'Total revenue',
    sales: 'Sales',
    revenue_share: 'Revenue Share',
    store_sales: 'Store sales',
    total_amount_orders: 'Total amount of orders',
    widget_analytics: 'Widget analytics',
    choose_widget_name: 'Choose widget name',
    choose_widget_type: 'Choose widget type',
    select_widget_type_to_compare: 'Select widget type to compare',
    choose_one_of_widgets_by_name: 'Choose one of the widgets by name',
    widget_data: 'Widget data',
    condition_receiving_data: 'Condition receiving data',
    other_sources: 'Other sources',
    on_unique_visits: 'on unique visits',
    on_unique_leads: 'on unique leads',
    leads_unsubscribed_from_all_mailings: 'Leads unsubscribed from all mailings',
    amount_of_new_leads: 'Amount of new leads',
    unsubscribed_discovered_leads_ratio: 'Unsubscribed / discovered leads ratio',
    total_sent: 'Number of emails sent',
    total_opened: 'Number of open emails',
    total_clicked: 'Number of clicks on the links in the email',
    conversion: 'Conversion',
    absolute_conversion: 'Absolute conversion',
    goods_that_are_most_often_bought: 'Goods that are most often bought',
    goods_that_are_most_often_added_to_cart_but_not_bought:
      'Goods that are most often added to cart, but not bought',
    goods_that_are_most_often_viewed: 'Goods that are most often viewed',
    goods_that_are_most_often_viewed_but_not_bought:
      'Goods that are most often viewed but not bought',
    offer_name: 'Offer name',
    number_of_purchases: 'Purchases',
    number_of_cart_additions: 'Cart additions',
    number_of_views: 'Views',
    website_page: 'Website page',
    period_cannot_be_more_than_one_month: 'Period cannot be more than one month',
    kpi: {
      arpv_definition:
        'average cost of each visit, i.e. how many roubles one visitor brings on average',
      revenue: 'Revenue',
      traffic_volume_visitor: 'Traffic volume (visitor)',
      arpl_definition: 'average revenue per lid',
      traffic_volume_lids: 'Traffic volume (lids)',
      arppu_definition: 'average revenue per customer',
      customers_who_made_order: 'Customers who made an order',
      average_check_definition: 'average order amount at your online store',
      number_orders: 'Number of orders',
      purchase_rate_definition: 'average purchase frequency per customer',
      number_unique_customers: 'Number of unique customers',
      repeat_customer_rate_definition: 'percentage of customers who placed more than 1 order',
      number_unique_multi_customers:
        'Number of unique customers, who have made more than one purchase',
      car_definition: 'percentage of abandoned baskets',
      paid_offers_rate_definition: 'order bookings per quantity paid',
      number_of_bookings_orders: 'Number of bookings orders',
      number_of_paid_orders: 'Number of paid orders',
      total_orders: 'Total orders',
      orders_completed: 'Orders completed',
      income: 'Income',
      orders: 'Orders',
      carts: 'Carts'
    },
    sales_funnel_chart: {
      total_visits: 'Visited the site',
      total_offer_views: 'Product pages viewed',
      total_additions_to_cart: 'Added to cart',
      total_orders_made: 'Made an order'
    }
  },
  widget: {
    smart_offer: 'smart-offer',
    social_proof: 'social-proof',
    subscribe: 'subscribe',
    wish_list: 'wish-list',
    generic: 'generic',
    notification: 'notification',
    recommendations: 'recommendations'
  },
  instruments: {
    no_delay: 'No delay',
    started: 'Started',
    most_popular: 'Most popular',
    clicks: 'Clicks',
    open: 'Open',
    mailing_date: 'Campaign date',
    delivered: 'Delivered',
    sent: 'Sent',
    newsletter_name: 'Campaign name',
    unsubscribed: 'Unsubscribed',
    last_activity: 'Last activity',
    new_mass_email_campaign: 'New mass email campaign',
    new_trigger_email_campaign: 'New trigger email campaign',
    autocast_name: 'Autocast name',
    email_template: 'Email template',
    sender_name: 'Sender name',
    sender_address: 'Sender address',
    email_subject: 'Email subject',
    dispatch_delay: 'Dispatch delay (minutes)',
    dispatch_interval: 'Dispatch interval (hours)',
    time_after_last_order: 'Time after last order (hours)',
    autocast_type: 'Autocast type',
    linked_widget: 'Linked widget (optional)',
    do_not_send_emails: 'Do not send emails',
    confirmation_of_subscription_is_required_for_sending_autocast:
      'Confirmation of subscription is required for sending autocast',
    disable_the_banner_display_when_email_is_clicked:
      'Disable the banner display when email is clicked',
    periodical: 'Periodical',
    hour_of_dispatch: 'Hour of dispatch',
    per_day_emails_upper_limit: 'Per day emails upper limit',
    delivery_days: 'Delivery days',
    conditions: 'Conditions',
    a_b_testing: 'A/B testing',
    add_a_test: 'Add a test',
    testing_name: 'Testing name',
    choose_autocast: 'Choose autocast',
    choose_template: 'Choose template',
    more: 'More',
    and: 'AND',
    or: 'OR',
    contains: 'Contains',
    does_not_contain: 'Not contain',
    test_autocast: 'Test autocast',
    sending_time: 'Sending time',
    chunk_size: 'Chunk size',
    interval_between_segments: 'Interval between segments',
    provider: 'Provider',
    to: 'To',
    address: 'Address',
    list_name: 'List name',
    campaign_settings: 'Campaign settings',
    email: 'E-mail',
    enter_name_of_autocast: 'Enter name of autocast',
    enter_name_of_emails: 'Enter name of emails',
    alert: 'Select a parameter or group of parameters to create an email campaign',
    enter_value: 'Enter value',
    choose_a_condition: 'Choose a condition',
    target_audience: 'Target audience',
    enter_motivation: 'Enter motivation',
    enter_instruction: 'Enter instruction',
    enter_test_mail_recipient_addresses: 'Enter test mail recipient addresses',
    send_test_emails: 'Send test emails',
    send_test_emails_for_autocast: 'Send test emails for autocast',
    send_test_emails_for_selected_emails: 'Send test emails for selected emails',
    enter_test_number: 'Enter test number',
    emails_creation_date: 'Emails creation date',
    autocast_creation_date: 'Autocast creation date',
    date_modified: 'Date Modified',
    sample: 'Sample',
    emails_total: 'Emails total',
    emails_delivered: 'Emails delivered',
    pending: 'Pending',
    delivery_errors: 'Delivery errors',
    to_send: 'To send',
    opened: 'Opened',
    clicked: 'Clicked',
    web_preview: 'Web preview',
    recipients: 'Recipients',
    include_test_emails: 'include test emails?',
    filters: 'Filters',
    date: 'Date',
    delivery_date: 'Delivery date',
    dispatch_time: 'Dispatch time',
    time_of_delivery: 'Time of delivery',
    information_about_emails: 'Information about emails',
    information_about_webpush: 'Web push campaign information',
    webpush_total: 'Total pushes',
    webpush_sent: 'Sent',
    webpush_shown: 'Shown',
    webpush_clicked: 'Clicks',
    webpush_closed: 'Closed without click',
    webpush_dismissed: 'Closed without click',
    webpush_crashed: 'Delivery errors',
    webpush_statuses: {
      new: 'Waiting to send',
      processing: 'Processing',
      sent: 'Sent',
      shown: 'Shown',
      clicked: 'Clicked',
      closed: 'Closed',
      dismissed: 'Closed',
      crashed: 'Error'
    },
    information_about_autocast: 'Information about autocast',
    take_into_account_activity_during_the_delay_period:
      'Take into account activity during the delay period',
    choose_a_condition_block: 'Choose a condition block',
    multilead_is_created: 'Multilead was created',
    multilead_order_status: 'Order presence',
    multilead_status: 'Customer status',
    order_status: 'Order status',
    visit_is_active: 'The visit is active',
    email_status: 'Mailing status',
    days_since_last_buy: 'Days since last purchase (if exists)',
    days_since_purchase: 'Days from the purchase',
    offer_purchase_period: 'Purchase period',
    periodic_purchase_last_update: 'Days since last recurring purchase',
    days_before_next_predictable_periodic_purchase: 'Days before next periodic purchase',
    days_after_skipped_periodic_purchase: 'Days after missed recurring purchase',
    not_attend: 'Did not visit(in days)',
    days_to_birthday: 'Days left until birthday',
    subscription_type: 'Subscribtion type',
    email_contains: 'Mails',
    visit_type: 'Visit result',
    form_submitted: 'Form submitted',
    visited_page: 'Visited page',
    check_if_parameters_are_set_properly: 'Check if parameters are set properly',
    check_if_parameters_are_set_properly_for_conditions_block:
      'Check if parameters are set properly for conditions block',
    error_save_autocast: 'Error save autocast',
    the_value_must_be_numeric: 'The value must be numeric',
    enter_a_valid_email: 'Enter a valid email',
    no_template_selected: 'No template selected',
    the_field_must_be_between_1_and_31: 'The field must be between 1 and 31',
    the_field_must_be_between_1_and_23: 'The field must be between 1 and 23',
    maximum_nesting_level: 'Maximum nesting level',
    maximum_number_of_blocks: 'Maximum number of blocks',
    maximum_number_of_conditions: 'Maximum number of conditions',
    confirmation_of_subscription_is_required_for_sending_autocast:
      'Confirmation of subscription is required for sending autocast',
    purchased_offer: 'Name of the purchased item',
    unopened_mass_messages: "Didn't open the latest bulk emails",
    opened_mass_messages: "Did open the latest bulk emails",
    last_mass_messages_count: 'Received letters from the last N mailing lists',
    multilead_message: 'Sent mailing (multilead)',
    auto_cust: {
      limitation_email: 'The number of emails can be no more than 10',
      choose_email: 'You must specify at least 1 email',
      choose_ab_test: 'Choose an A/B test',
      send_test_success: 'Test email sent successfully',
      is_active: 'Is active',
      the_number_cannot_be_more_than: 'The number cannot be more than',
      the_maximum_number_of_characters: 'The maximum number of characters',
      no_last_activity: 'No last activity',
      autocast_has_been_archived: 'Autocast has been archived',
      autocasts_has_been_archived: 'Autocasts has been archived',
      autocast_has_been_unarchived: 'Autocast has been unarchived',
      autocasts_has_been_unarchived: 'Autocasts has been unarchived',
      autocast_has_been_activated: 'Autocast has been activated',
      autocasts_has_been_activated: 'Autocasts has been activated',
      autocast_has_been_deactivated: 'Autocast has been deactivated',
      autocasts_has_been_deactivated: 'Autocasts has been deactivated',
      archive_autocast: 'Archive autocast',
      unarchive_autocast: 'Unarchive autocast',
      deactivate_autocast: 'Deactivate autocast',
      active_autocast: 'Active autocast',
      must_select_at_least_1_autocast: 'Must select at least 1 autocast',
      selected_autocast: 'Selected autocast',
      deactivate: 'Deactivate',
      activate: 'Activate',
      unarchive: 'Unarchive',
      archive: 'Archive',
      show_archived_mailing_campaigns: 'Show archived autocast',
      hide_archived_mailing_campaigns: 'Hide archived autocast',
      add_a_condition: 'Add a condition',
      add_a_conditions_block: 'Add a conditions block',
      paid: 'Paid',
      submitted: 'Submitted',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      daily: 'Daily',
      visits: 'Visits',
      view: 'View Productsiew',
      cart: 'Adding to cart',
      pre_order: 'Start order',
      order: 'Order',
      category_view: 'Category view',
      unavailable_view: 'Unavailable items view',
      in_stock: 'In stock',
      discount: 'Discount',
      day_of_week: 'Day of week',
      day_of_month: 'Day of month',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      starts_with: 'Starts with',
      does_not_start_with: 'does not start with',
      did_not_visit_in_days: 'Did not visit(in days)',
      statistics_for_ab_testing: 'Statistics for A/B testing',
      lacking_ab_testing: 'Lacking A/B testing',
      enter_day_of_month: 'Enter the day of the month',
      copy_autocast: 'Copy autocast | Copy autocasts | Copy autocasts',
      autocast_with_that_name_already_exists: 'Autocast with that name already exists',
      autocast_successfully_copied: 'Autocast successfully copied',
      autocasts_successfully_copied: 'Autocasts successfully copied',
      enter_name_of_new_autocast:
        'Enter name of new autocast | Enter names of new autocasts | Enter names of new autocasts',
      default_values: 'Default values',
      set_default_values: 'Set default values',
      defaults_values_changed: 'Defaults values changed',
      apply_defaults_values: 'Apply defaults values',
      apply_defaults_values_question:
        'Are you sure you want to apply the default values to selected autocast | Are you sure you want to apply the default values to selected autocasts | Are you sure you want to apply the default values to selected autocasts',
      selected_autocast: 'Selected autocast | Selected autocasts | Selected autocasts',
      you_must_set_at_least_one_default_value: 'You must set at least one default value',
      autocast_successfully_updated: 'Autocast successfully updated',
      autocasts_successfully_updated: 'Autocasts successfully updated',
      email_statuses: {
        delivered: 'Delivered',
        dropped: 'Dropped',
        opened: 'Opened',
        new: 'Awaiting shipment',
        sent: 'Delivery attempt'
      },
      linked_tools_warning: 'Some autocasts are linked to other tools'
    },
    ab_test: {
      active_ab_testing: 'Active A/B testing',
      ab_testing: 'A/B testing',
      autocast: 'Autocast',
      create_ab_test: 'Create A/B test',
      test_name: 'Test name',
      required_field: 'Required field',
      enter_a_valid_value: 'Enter a valid value',
      mandatory_to_choose: 'Mandatory to choose',
      validation_not_passed: 'Validation not passed',
      no_change: 'No change',
      save_changes_to_autocast: 'Save changes to autocast',
      saving_changes: 'Saving changes',
      amount_must_be_no_more: 'Amount must be no more',
      data_saved: 'Data saved'
    },
    message_campaign: {
      sender_mail: 'Sender mail',
      select_channel: 'Select message channel',
      template_selection: 'Template selection',
      disable_banner_display: 'Disable banner display when clicking on a letter',
      segment_size: 'Segment size',
      segmant_delay: 'Segmant delay',
      single_address: 'Single address',
      segment_name: 'Segment name',
      lead_id: 'Lead ID',
      parameter_is_optional: 'Parameter is optional',
      segment_size_delay_condition:
        'Parameters segment size and segment delay must be both filled or both empty',
      create_email_question: 'Are you sure you want to create a newsletter',
      error_create_email: 'Error creating newsletter',
      email_success_created: 'Newsletter successfully created',
      network_error_check_manually: 'A network error occurred. The newsletter may have been created successfully. Please check the newsletter list or try creating again.',
      promocodes: 'Selecting a promocode category',
      promocode_in_template: 'The template has a promocode',
      delete_no_permission: 'No permission to delete this campaign',
      delete_not_found: 'Campaign not found'
    },
    widgets: {
      error_config_file: 'Invalid config file format',
      export_config_success: 'Config exported successfully',
      import_config: 'Import config',
      export_config: 'Export config',
      delete_widget: 'Delete widget | Delete widgets | Delete widgets',
      confirm_popup_delete_body_text:
        'Are you sure to delete the selected widget | Are you sure to delete the selected widgets | Are you sure to delete the selected widgets',
      copy_widget: 'Copy widget | Copy widget | Copy widget',
      confirm_popup_copy_body_text:
        'Enter a name for the new widget | Enter the names of the new widgets | Enter the names of the new widgets',
      name_selected_widget:
        'Name of selected widget | Names of selected widgets | Names of selected widgets',
      action_selection: 'Action selection',
      actions_not_available_until_you_select_widgets:
        'Actions are not available until you select widgets',
      widget_name: 'Widget name',
      active: 'Active',
      not_active: 'Not active',
      launch_date: 'Launch date',
      activate_widget: 'Activate widget',
      deactivate_widget: 'Deactivate Widget',
      confirm_popup_activate_body_text: 'Are you sure to activate the selected widget',
      confirm_popup_deactivate_body_text: 'Are you sure to deactivate the selected widget',
      widget: 'Widget',
      enter_widget_name: 'Enter widget name',
      widget_type: 'Widget type',
      widget_creation: 'Widget creation',
      widget_editing: 'Widget editing',
      json_config: 'JSON config',
      widget_on: 'Widget on',
      widget_off: 'Widget off',
      basic_settings: 'Basic settings',
      variables: 'variables',
      code: 'code',
      triggers: 'Triggers',
      choose_display_conditions: 'Choose display conditions',
      widget_group: 'Widget group',
      trigger: 'Trigger',
      timer: 'Timer',
      value: 'Value',
      idle_timer: 'Inactivity timer',
      mouse_out: 'Mouse off-screen',
      localStorageKey: 'LocalStorage key',
      parameters: 'Parameters',
      cookie: 'Cookie',
      localstorage_variable: 'LocalStorage variable',
      global_variable: 'Global variable',
      type: 'Type',
      select_type: 'Select type',
      select_name: 'Select name',
      operator: 'Operator',
      page_url: 'Page url',
      pages_viewed: 'Pages viewed',
      widget_shown: 'Widget shown',
      more: 'More',
      less: 'Less',
      contain_regexp: 'Contain RegExp',
      not_contain_regexp: 'Not contain RegExp',
      name_of_new_widget: 'The name of new widget',
      widget_was_removed: 'Widget was removad',
      widgets_was_removed: 'Widgets have been removed',
      variable_assignment: 'Variable assignment',
      variable_name: 'Variable name',
      widget_updated_successfully: 'Widget updated successfully',
      widget_locked_by_another_user: 'Widget is already being edited by another user',
      widget_lock_error: 'Failed to lock the widget',
      no_abtests: 'No A/B tests',
      active_abtests: 'Active tests',
      finished_abtests: 'Completed tests',
      no_finished_abtests: 'No completed tests',
      start_date: 'Start date',
      activity_period: 'Activity period',
      test_statistics: 'Test statistics',
      metric: 'Metric',
      finish_test: 'Finish test',
      finishing_abtest: 'Finishing test "{name}"',
      finish_abtest_hint: 'Select the widgets you want to keep active after the test ends.\nBy default, all widgets in the test are deactivated when the test is finished.',
      keep_in_work: 'Keep active',
      abtest_successfully_finished: 'A/B test finished successfully',
      abtest_finish_error: 'Failed to finish A/B test',
      abtest_stats_error: 'Failed to load test statistics',
      stats_metrics: {
        popup_view: 'Popup views',
        popup_view_3s: 'Popup views 3 sec.',
        popup_view_10s: 'Popup views 10 sec.',
        close: 'Closes',
        fill: 'Form fills',
        conversion: 'Conversion'
      },
      delete_test: 'Delete test',
      enter_test_name: 'Enter test name',
      abtest_title: 'Select the widget group and name to add to the test',
      add_widget: 'Add widget',
      share_of_show: 'Share of show',
      no_widgets: 'No widgets',
      all_tests_must_contain_widgets: 'Test must contain at least 2 widgets',
      not_all_share_show_widget_current: 'Sum of the share of test should be equal to 100',
      are_you_sure_you_want_to_remove_abtest: 'Are you sure you want to remove the A/B test',
      removing_abtest: 'Removing A/B Test',
      abtest_successfully_deleted: 'A/B test successfully deleted',
      name_selected_abtest: 'Name of selected A/B test',
      abtest_saved: 'A/B test saved',
      choose_value: 'Choose value',
      activate_at_least_two_widgets: 'Activate at least two widgets',
      fill_in_empty_test: 'Fill in an empty test',
      widget_name_is_exist: 'Widget with this name already exists'
    },
    alerts: {
      user_alerts: 'User alerts',
      history: 'History',
      сreate_alert: 'Create alert',
      user_alert: 'User alert',
      alert_name: 'Alert name',
      user_alert_editor_notification_text:
        'Select a parameter or group of parameters to create an alert',
      send_to_mail: 'Send to mail',
      alert_parameters: 'Alert parameters',
      sender: 'Sender',
      send_only_with_phone: 'Send only with phone',
      send_again: 'Send again',
      webhook_alert: 'Alert with webhook',
      number_of_visits: 'Number of visits',
      lead_mail_is_correct: 'Lead mail is correct',
      delete_user_alert: 'Delete user alert | Delete user alerts | Delete user alerts',
      confirm_popup_delete_body_text:
        'Are you sure to delete the selected user alert | Are you sure to delete the selected user alerts | Are you sure to delete the selected user alerts',
      name_selected_user_alert:
        'Name of selected user alert | Names of selected user alerts | Names of selected user alerts',
      user_alert_was_removed: 'User alert deleted successfully',
      user_alerts_was_removed: 'User alerts deleted successfully',
      user_alert_updated_successfully: 'User alert updated successfully',
      activate_user_alert: 'Activate user alert | Activate user alerts | Activate user alerts',
      confirm_popup_activate_body_text:
        'Are you sure to activate the selected user alert | Are you sure to activate the selected user alerts | Are you sure to activate the selected user alerts',
      user_alerts_updated: 'User alerts updated',
      user_alert_updated: 'User alert updated',
      deactivate_user_alert: 'Dectivate user alert | Dectivate user alerts | Dectivate user alerts',
      confirm_popup_deactivate_body_text:
        'Are you sure to dectivate the selected user alert | Are you sure to dectivate the selected user alerts | Are you sure to dectivate the selected user alerts',
      lead_name: 'Lead name',
      lead_mail: 'Lead mail',
      lead_phone: 'Lead phone',
      no_mail: 'No mail',
      no_phone: 'No phone',
      delete_user_alert_notification:
        'Delete user alert notification | Delete user alert notifications | Delete user alert notifications',
      confirm_popup_delete_notification_body_text:
        'Are you sure you want to delete the selected notification | Are you sure you want to delete the selected notifications | Are you sure you want to delete the selected notifications',
      name_selected_user_alert_notification:
        'Name of selected notification | Names of selected notifications | Names of selected notifications',
      notifications_deleted: 'Notifications Deleted',
      notification_deleted: 'Notification Deleted',
      download_to_csv: 'Download to CSV',
      export_csv_user_alert_notification:
        'Send notification to email | Send notifications to email | Send notifications to email',
      sort_field: 'Sort field',
      sort_direction: 'Sort direction'
    },
    subscriptions: {
      product_subscriptions: 'Product Subscriptions',
      description: 'Manage user subscriptions for notifications about discounts and product availability',
      no_subscriptions: 'No subscriptions yet',
      no_subscriptions_description: 'User subscriptions for discount and product availability notifications will be displayed here',
      email: 'Email',
      offer_name: 'Product Name',
      type: 'Type',
      subscription_type: 'Subscription Type',
      time_added: 'Time Added',
      time_activated: 'Time Activated',
      actions: 'Actions',
      date: 'Subscription Date',
      product: 'Product',
      all_types: 'All Types',
      price_drop: 'Price Drop',
      availability: 'Availability',
      subscription_period: 'Subscription Period',
      search: 'Search',
      search_by: 'Search By',
      discount: 'Discount',
      base_price: 'Price',
      discount_size: 'Discount Size',
      status: 'Status',
      ready: 'Ready',
      not_ready: 'Not Ready'
    },
    loyalty: {
      loyalty: 'Loyalty',
      rules: 'Rules',
      loyalty_categories: 'Loyalty - Categories',
      loyalty_rules: 'Loyalty - Rules',
      category_name: 'Category name',
      discount_in_percent: 'Discount in %',
      discount_size: 'Discount size',
      create_new_category: 'Create new category',
      category_type: 'Category type',
      category_successfully_created: 'Category successfully created',
      delete_category: 'Delete category',
      confirm_popup_delete_category_body_text:
        'Are you sure you want to delete the selected category',
      selected_category_name: 'Selected category name',
      category_successfully_deleted: 'Category successfully deleted',
      loyalty_category: 'Loyalty category',
      amount_of_purchases: 'Amount of purchases',
      select_conditions: 'Select conditions',
      value_must_be_integer_or_float: 'Value must be integer or float',
      rule_successfully_created: 'Rule successfully created',
      delete_rule: 'Delete rule',
      confirm_popup_delete_rule_body_text: 'Are you sure you want to delete the selected rule',
      selected_rule_condition:
        'Selected rule condition | Selected rule conditions | Selected rule conditions',
      rule_successfully_deleted: 'Rule successfully deleted'
    },
    business_rules: {
      title: 'Business rule',
      add_business_rule: 'Add a business rule',
      name_of_business_rule: 'Name of business-rule',
      name_of_business_rule_mobile: 'Rule name',
      priority_rule: 'Rule priority',
      number_of_links: 'Number of links',
      product: 'Product',
      category: 'Category',
      product_category: 'Product category',
      delete_rule: 'Delete rule',
      confirm_popup_delete_body_text: 'Are you sure you want to delete the selected rule',
      name_selected_rule: 'Name of the selected rule',
      edit_business_rule: 'Edit business rule',
      create_business_rule: 'Create business rule',
      rule_removed: 'Business rule removed',
      configuration_selection: 'Choosing a configuration for a business rule',
      priority1: 'First priority',
      priority2: 'Second priority',
      priority3: 'Third priority',
      select_product: ' Select a product',
      select_category: 'Select a category',
      apply_with_recommendation: 'Apply with recommendations',
      press_for_search: 'Click to select',
      recommend_with_product: 'Recommend with product',
      not_recommend_with_product: 'Do not recommend with product',
      recommend_with_category: 'Recommend with category',
      not_recommend_with_category: 'Do not recommend with category',
      assigned_product_recommendation: 'Assigned product recommendation',
      start_searching_to_match: 'Start searching to match',
      products_found: 'Products found',
      categories_found: 'Categories found',
      recommendations_found: 'Recommendations found',
      warning_not_selected_product: 'You have not selected a product to create a business rule',
      warning_not_selected_category: 'You have not selected a category to create a business rule',
      warning_not_selected_name_of_rule: 'Enter a name for the business rule',
      changed_priority: 'You have changed the priority',
      rule_created: 'Business rule created',
      rule_updated: 'Business rule updated',
      no_rights: 'You have no rights'
    },
    recommendation: {
      title: 'Recommendation',
      activate: 'Activate the recommendation',
      deactivate: 'Disable recommendation',
      confirm_popup_activate_body_text: 'Are you sure you want to activate the recommendation',
      confirm_popup_deactivate_body_text: 'Are you sure you want to disable the recommendation',
      name_selected: 'Name of the selected recommendation',
      name_of_service: 'Service name',
      algorithm: 'Algorithm',
      delete_recommendation: 'Remove recommendation',
      confirm_popup_delete_body_text: 'Are you sure you want to remove the recommendation',
      edit_recommendation: 'Edit recommendation',
      alert_success: 'You have changed the priority of the business rules',
      alert_danger: 'Business rule cannot be moved to another category',
      only_available: 'Recommend only available products',
      name_filter: 'Filtering products by name',
      price_filter: 'Filtering products by similarity in price',
      recommendation_on: 'Recommendation enabled',
      recommendation_off: 'Recommendation disabled',
      recommendation_updated: 'Recommendation updated'
    }
  },
  datepicker: {
    periods: 'Periods',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    start_period: 'Start',
    end_period: 'End'
  },
  intro_training: {
    welcome_aboard: 'Welcome aboard!',
    marketing_management: 'Marketing management',
    start: 'Start',
    later: 'Later',
    start_module_question: "Let's get acquainted with the functionality of the product?",
    next: 'Next',
    scene_leads_first_text:
      'In the "lids" tab you can find information about the actions of each user of the site who somehow left any data about himself.',
    scene_leads_second_text:
      "The data can be sorted by traffic source/date of arrival/date of last visit/status and completed form, as well as information on the quality of the lid (whether he buys orders or not) and quick access to each client's card.",
    scene_leads_third_text:
      'In the "Segments" tab, you can combine leads by many conditions and form samples to create individual proposals to groups.',
    scene_instruments_first_text:
      'In this section you will find all the tools currently available. The current working status is also presented in this section.',
    scene_instruments_second_text:
      'You can control how the tools work in this section. Add new widgets, edit email templates and much more.',
    scene_instruments_third_text:
      'Summary of the effectiveness of each tool within each block. Actual information is updated in real time.',
    scene_reports_first_text:
      'All available reports are collected in one section. Efficiency of recommendations - sales after clicking on recommendations. Available for each widget separately or a full report for all widgets.',
    scene_reports_second_text:
      'Mailing and Autocasts report - sales after receiving an automatic trigger letter or letter sent as part of a mass mailing.',
    scene_reports_third_text:
      ' + bonus - through analytics - evaluate the effectiveness of each order channel.',
    scene_analytics_first_text:
      'In the Analytics section, the user can deeply analyze the results of the service and the overall efficiency of the store.',
    scene_analytics_second_text:
      'The summary of analytical information is presented in the form of widgets, here we can see the statistics of visits, the dynamics of growth in the number of lids, statistics on mass and trigger mailings and the effectiveness of the widgets.',
    scene_analytics_third_text:
      'Each widget can be expanded and get a detailed picture of each indicator, select the desired period, source and other customizable parameters.',
    scene_color_switcher_title: 'Changing interface theme',
    scene_color_switcher_text:
      'You can choose a color scheme (dark or light) based on your personal preferences, as well as switch between modes during work sessions.',
    scene_settings_title: 'Block "Settings"',
    scene_settings_text:
      'When you start working with "Leadhit" service, we recommend you to go to the "Settings" module for convenient management of information and notifications. You can also set up access and activate tools in the module.',
    continue_later: 'Continue later',
    control_training_buttons_text: 'You can control the opening tour using the buttons'
  },
  tariffs: {
    information_about_tariffs: 'Information about tariffs',
    functionality: 'Functionality',
    per_month: 'per month',
    on_the_leadhit_side: 'On the LeadHit side',
    compatibility_check: 'Compatibility check',
    forms_connection: 'Forms Connection',
    feed_check: 'Feed Check',
    dns_preparation: 'DNS Preparation',
    connecting_postmasters: 'Connecting postmasters',
    cross_domain_integration: 'Cross-domain integration',
    finished_products: 'Finished products',
    smartoffer: 'Smartoffer',
    mobile_smartoffer: 'Mobile Smartoffer',
    triggered_mailings: 'Triggered mailings',
    abandoned_offer_view: 'Abandoned offer view',
    wish_list: 'Wish-list',
    collection_of_personal_data: 'Collection of personal data',
    abandoned_cart: 'Abandoned cart',
    post_sale: 'Post-sale',
    inactive_client: 'Inactive client',
    subscribe_for_product_price_reduction: 'Subscribe for product price reduction',
    subscribe_for_product_availability: 'Subscribe for product availability',
    average_bill_magnifier: 'Average bill magnifier',
    social_proof: 'Social proof',
    additional_features: 'Additional features',
    standard_widget_templates: 'Standard widget templates',
    adaptation_of_widgets_for_the_clients_site: "Adaptation of widgets for the client's site",
    individual_algorithm_for_displaying_widgets: 'Individual algorithm for displaying widgets',
    design_change: 'Design change',
    algorithms_change: 'Algorithm change',
    ab_testing_of_widgets: 'A/B testing of widgets',
    gamification: 'Gamification',
    individual_widget_design: 'Individual widget design',
    working_with_different_types_of_clients: 'Working with different types of clients',
    limitations: 'Limitations',
    once_monthly: 'once/monthly',
    abandoned_view_of_an_expensive_product: 'Abandoned view of an expensive product',
    abandoned_view_of_products_out_of_stock: 'Abandoned view of products out of stock',
    welcome_series: 'Welcome-series',
    nps_poll: 'NPS-poll',
    review: 'review',
    birthday: 'Birthday',
    abandoned_view_of_product_category: 'Abandoned view of product category',
    products_of_regular_demand: 'Products of regular demand',
    regular_new_products: 'Regular new products',
    regular_promotions: 'Regular promotions',
    transaction_mailings: 'Transaction mailings',
    standard_email_templates: 'Standard email templates',
    visual_template_editor: 'Visual template editor',
    adaptation_of_emails_to_the_clients_site: "Adaptation of emails to the client's site",
    algorithm_change: 'Algorithm change',
    individual_algorithm_of_trigger_mailings: 'Individual algorithm of trigger mailings',
    ab_testing_of_triggered_mailings: 'A/B testing of triggered mailings',
    individual_promotional_codes_in_trigger_mailings:
      'Individual promotional codes in trigger mailings',
    individual_recommendations_in_triggered_mailings:
      'Individual recommendations in triggered mailings',
    limitation_on_the_number_of_emails_received_by_lead:
      'Limitation on the number of emails received by lead',
    support_of_regionalization: 'Support of regionalization',
    individual_template_design: 'Individual template design',
    configure_transactional_mailings: 'Configure transactional mailings',
    limit_on_the_number_of_emails_sent_per_month_not_more_than:
      'Limit on the number of emails sent per month, not more than',
    welcome_series_consists_of_emails: 'Welcome-series consists of ... emails',
    mass_mailings: 'Mass mailings',
    opportunities: 'Opportunities',
    self_service_mailing: 'Self-service mailing',
    mailing_made_by_leadhit: 'Mailing made by LeadHit',
    import_your_own_database: 'Import your own database',
    verification_of_the_imported_database: 'Verification of the imported database',
    individual_recommendations_in_mass_mailings: 'Individual recommendations in mass mailings',
    mailing_made_by_leadhit_per_month_no_more_if_you_need_more_often_contact_us:
      'Mailing made by LeadHit, per month, no more (you need more often - contact us)',
    verification_is_paid_additionally_depending_on_the_size_of_the_base:
      'Verification is paid additionally, depending on the size of the base',
    import_is_possible_strictly_after_verification:
      'Import is possible strictly after verification',
    recommendation_service_integration_by_api: 'Recommendation service integration by API',
    service_integration_via_widget_by_leadhit: 'Service integration via widget (by LeadHit)',
    setting_up_business_rules: 'Setting up business-rules',
    algorithms: 'Algorithms',
    alarm_system: 'Alarm System',
    abandoned_cart_notifications: 'abandoned cart notifications',
    ability_to_set_other_alerts: 'Ability to set other alerts',
    project_support: 'Project support',
    specialists: 'Specialists',
    account_manager: 'Account manager',
    designer: 'Designer',
    copywriter: 'Copywriter',
    layout_designer: 'Layout designer',
    in_gap_tariff_support_available_on_ticket_system:
      'in the Gap tariff support is available on the ticket system',
    project_specialist_working_hours_are_limited_to_hours:
      'project specialist working hours are limited to ... hours',
    add_info_email_marketing:
      'The tariff does not provide for the work of specialists on mass mailings. If you are interested in email marketing (comprehensive maintenance of mass mailings), please contact us in any way convenient for you.',
    analytics_and_statistics: 'Analytics and statistics',
    tariff_selection: 'Tariff selection',
    lead_collection: 'Lead collection',
    converting_anonymous_visitors_to_leads: 'Converting anonymous visitors to leads',
    base_collection: 'Base collection',
    returning_customers_to_the_funnel: 'Returning customers to the funnel',
    personalization_of_trigger_mailings: 'Personalization of trigger mailings',
    working_with_mobile_traffic: 'Working with mobile traffic',
    personalization_of_email_marketing_and_website:
      'Personalization of e-mail marketing and website',
    collecting_the_base_and_returning_customers_to_purchase:
      'Collecting the base and returning customers to purchase',
    customizing_email_marketing: 'Customizing e-mail marketing',
    customizing_the_site: 'Customizing the site',
    personalization_of_email_marketing_for_complex_scenarios:
      'Personalization of e-mail marketing for complex scenarios',
    website_personalization_for_complex_scenarios: 'Website personalization for complex scenarios',
    full_customization_of_communications_with_clients:
      'Full customization of communications with clients'
  },
  stripo_template_categories: {
    features: {
      title: 'Features',
      amp: 'AMP',
      accordion_menu: 'Accordion Menu',
      css_animations: 'CSS animation',
      carousel: 'Carousel',
      countdown_timer: 'Countdown Timer',
      image_rollover: 'Image Rollover',
      video: 'Video',
      gamification: 'Gamification'
    },
    industries: {
      title: 'Industries',
      other: 'Other',
      electronics: 'Electronics',
      clothes: 'Clothes',
      children_products: 'Children products',
      jewelry: 'jewelry',
      art: 'Art',
      books: 'Books',
      auto_moto: 'Auto Moto',
      construction: 'Construction',
      animals: 'Animals',
      products: 'Products',
      ho_re_ca: 'HoReCa',
      tourism: 'Tourism',
      transport: 'Transport',
      beauty: 'Beauty',
      consulting: 'Consulting',
      lawyers: 'Lawyers',
      software: 'Software',
      real_estate: 'Real estate',
      government: 'Government',
      beverages: 'Beverages',
      education: 'Education',
      finance: 'Finance',
      gadgets: 'Gadgets',
      food: 'Food',
      gifts_flowers_handmade: 'Gifts flowers handmade',
      hotels: 'Hotels',
      photography: 'Photography',
      publications_blogging: 'Publications_blogging',
      sports: 'Sports',
      webinars: 'Webinars',
      no_name: 'no_name'
    },
    seasons: {
      title: 'Seasons',
      world_tourism_day: 'World Tourism Day',
      summer_time: 'Summer Time',
      cyber_monday: 'Cyber Monday',
      halloween: 'Halloween',
      labor_day: 'Labor Day',
      back_to_school: 'Back to school',
      independence_day: 'Independence_day',
      fathers_day: 'Fathers Day',
      memorial_day: 'Memorial Day',
      mothers_day: 'Mothers Day',
      easter: 'Easter',
      st_patricks_day: 'St Patricks Day',
      st_valentines_day: 'St Valentines Day',
      christmas: 'Christmas',
      thanksgiving: 'Thanksgiving',
      black_friday: 'Black friday',
      new_year: 'New Year',
      super_bowl: 'Super bowl',
      womens_day: 'Womens Day',
      birthday: 'Birthday',
      global_shopping_festival: 'Global shopping festival',
      hanukkah: 'Hanukkah',
      spring: 'Spring',
      wedding_invitation: 'Wedding invitation'
    },
    types: {
      title: 'Types',
      abandoned_cart: 'Abandoned cart',
      alerts_and_notifications: 'Alerts & Notifications',
      apology: 'Apology',
      cold_emails: 'Cold emails',
      confirmation: 'Confirmation',
      discount: 'Discount',
      email_digest: 'Email digest',
      event_reminder: 'Event reminder',
      events: 'Events',
      follow_up: 'Follow-up',
      holidays: 'Holidays',
      interactive: 'Interactive',
      internal: 'Internal',
      invitation: 'Invitation',
      new_collection: 'New collection',
      order: 'Order',
      password_reset: 'Password reset',
      post_purchase: 'Post purchase',
      product_update: 'Product update',
      promo: 'Promo',
      retention_and_reactivation: 'Retention & Reactivation',
      sales: 'Sales',
      smart_elements: 'Smart elements',
      survey_and_feedback: 'Survey & Feedback',
      thank_you: 'Thank You',
      welcome: 'Welcome'
    }
  },
  web_push: {
    title_label: 'Title',
    title_set_in_mailing: 'Title is set when creating a campaign',
    body_required: 'Notification text cannot be empty',
    body_label: 'Text',
    test_send: 'Send test push',
    test_sending: 'Sending...',
    test_send_hint: 'The test push is delivered to this browser. The browser will ask for notification permission first.',
    test_send_success: 'Test push sent. Check your browser notifications.',
    test_send_error: 'Failed to send the test push. Check that the service worker is installed and notifications are allowed.',
    test_title_prompt: 'Enter a title for the test notification',
    test_title_required: 'Enter a title',
    test_permission_denied: 'Notifications for the control panel are blocked. Allow them in the site settings in the address bar.',
    test_render_error: 'Failed to substitute variables in the title or text',
    test_send_failed: 'Failed to send the test push',
    test_no_permission: 'You do not have permission to send a test web push'
  }
}



// WEBPACK FOOTER //
// ./src/languages/eng.js